import { ToursActivitiesCategory, type ToursActivity } from '@/entities/tour-activities/types';
import type { ActivityTypesResponse } from '@/shared/api/experience';

const asCategory = (raw?: string): ToursActivitiesCategory => {
  const k = (raw ?? '').toLowerCase() as ToursActivitiesCategory;

  return (Object.values(ToursActivitiesCategory) as string[]).includes(k) ? k : ToursActivitiesCategory.ACTIVE;
};

export function createToursActivitiesFromResource(
  items: ActivityTypesResponse,
  getLabel: (c: ToursActivitiesCategory) => string,
): ToursActivity[] {
  return items.map((item) => {
    const category = asCategory(item.category);

    return {
      ...item,
      category,
      categoryTitle: getLabel(category) || '',
    } as ToursActivity;
  });
}
